import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { refreshSession } from '../reducers/user-info';
import { isEmptyObject } from '../lib/tool';

const SessionHOC = WrappedComponent => {
    class SessionComponent extends React.Component {
        componentDidMount() {
            this.props.resetUserInfo();
        }
        render() {
            const {
                canSave,
                canShare,
                user,
                resetUserInfo,
                ...componentProps
            } = this.props;
            const isLogin = !isEmptyObject(user);
            return (
                <WrappedComponent                    
                    canSave={isLogin}
                    canShare={isLogin}
                    canCreateNew={isLogin}
                    {...componentProps}
                />
            )
        }
    }

    SessionComponent.propTypes = {
        canSave: PropTypes.bool,
        user: PropTypes.object,
        resetUserInfo: PropTypes.func
    };

    SessionComponent.default = {
        canSave: false,
        resetUserInfo: () => { }
    }

    const mapStateToProps = (state) => ({ user: state.session.session });

    const mapDispatchToProps = dispatch => ({
        resetUserInfo: () => refreshSession(dispatch)
    });

    return injectIntl(connect(
        mapStateToProps,
        mapDispatchToProps
    )(SessionComponent));
};

export {
    SessionHOC as default
}
